import { Injectable, inject, signal } from '@angular/core';
import { NexusApiService } from './nexus-api.service';
import { VersionInfo } from '../models/api.models';
import { environment } from '../../../environments/environment';

/** Holds version info for both frontend and backend. */
@Injectable({ providedIn: 'root' })
export class VersionService {
  private readonly nexusApiService = inject(NexusApiService);

  /** Frontend version from environment (injected by CI at build time). */
  readonly frontendVersion = environment.version;

  /** Backend version fetched from GET /api/v1/version. */
  readonly backendVersion = signal<VersionInfo | null>(null);
  readonly backendError = signal(false);

  /** Call once during app bootstrap. */
  load(): void {
    this.nexusApiService.getVersion().subscribe({
      next: (v) => this.backendVersion.set(v),
      error: () => this.backendError.set(true),
    });
  }
}
